export class ImportFile {
    constructor() {
        this.htmlInitialization();
    }

    htmlInitialization() {
        let _this = this;

        $("#upload_file_form").submit((e) => {
            e.preventDefault();
            _this.updateLoadingStatus(true);
            ($("#upload_file_form") as any).ajaxSubmit({
              url: $(this).attr("action"),
              type: "post",
              dataType: "JSON",
              success: (data) => {
                _this.updateLoadingStatus(false);
                console.log(data);
                $("#finished_status").show();
                $("#uploaded_status").show();
                $("#finished_stats").show();
                console.log(`<i class="fa fa-check text-success"></i>Detected ${data.total_records} Records<br>${data.failed} Error(s) Found<br>${data.print_lines} Lines to Print<br>${data.tags} Tags to Print`)
                $("#finished_stats").html(`<i class="fa fa-check text-success"></i>Detected ${data.total_records} Records<br>${data.failed} Error(s) Found<br>`);
                $("#submitUpload").hide();
                $("#proceedToPrinting").show();
                $("#btn-close-modal").hide();
                if(data.failed != 0) {
                    let log_items = ''
                    $.each(data.errors, function(i, error){
                        log_items += `${error.item}: ${error.errors}<br>`
                    });
                    $("#importing_error").html(log_items);
                    $("#importing_error").show();
                }
                $("#proceedToPrinting").on("click", function(){
                    window.location.reload();
                })
                $("#sn_import_file").val("");
              },
              error: ({responseJSON}) => {
                // showError(responseJSON.error);
                _this.updateLoadingStatus(false);
                console.log(responseJSON.errors);

                $("#importing_error").text(responseJSON.errors);
                $("#importing_error").show();
              }
            });
        });
    }

    updateLoadingStatus(loading){
        if(loading) {
          $(".import_loading").show();
          $(".import_not_loading").hide();
        } else {
          $(".import_loading").hide();
          $(".import_not_loading").show();
        }
    }
}
